import { formField } from "src/utils/constants"

export const NotificationFields = {
  
  Emails: { name: "Notification.Email", label: "Email" },
  }

export const NotificationFieldsRender = {
  emails: {
    fieldType: formField.multi_auto_dropdown,
    props: {
      name: NotificationFields.Emails.name,
      label: NotificationFields.Emails.label,
      options: [],
      freeSolo: true
    }
  }
}
